import { postRequest } from "../libs/AxiosService.util";
import { flowPost } from "../libs/WhatsappFlowClient.util";
import { mapFlowConversation, mapFlowMessages } from "../libs/WhatsappFlow.mapper";

/**
 * Conversation list — POST /api/conversations/list on whatsapp-api-flow.
 */
export async function fetchWhatsappConversations(params = {}) {
  const page = parseInt(params.page, 10) || 1;
  const limit = parseInt(params.limit, 10) || 15;
  const query = (params.q || params.search || "").trim();
  const r = await flowPost("/api/conversations/list", { query, limit, page });
  if (r?.error) return r;
  const inner = r.data || {};
  const mapped = (inner.conversations || []).map((c) => mapFlowConversation(c, null));
  return {
    ...r,
    data: {
      data: mapped,
      totalCount: inner.total ?? 0,
      page: (inner.page ?? page) - 1,
      limit: inner.limit ?? limit,
    },
  };
}

/**
 * Messages for a chat — POST /api/conversations/messages/list (contact is the WhatsApp digits key).
 * @param {string} _conversationId — unused; kept for call-site compatibility
 */
export async function fetchWhatsappMessages(_conversationId, params = {}, contact) {
  if (!contact) {
    return { error: true, message: "contact is required", authorization: true, response_code: 0 };
  }
  const page = parseInt(params.page, 10) || 1;
  const limit = parseInt(params.limit, 10) || 50;
  const r = await flowPost("/api/conversations/messages/list", { contact, limit, page });
  if (r?.error) return r;
  const inner = r.data || {};
  const mapped = mapFlowMessages(inner.messages || []);
  return { ...r, data: mapped };
}

/**
 * Send text — POST /api/whatsapp/send/text
 */
export async function serviceSendMessage(params) {
  const toRaw = params.to || params.contact;
  const to = toRaw != null ? String(toRaw).replace(/\D/g, "") : "";
  if (!to || !params.message) {
    return { error: true, message: "to and message are required", authorization: true, response_code: 0 };
  }
  const body = {
    to,
    message: params.message,
  };
  if (params.account_id != null && String(params.account_id).trim() !== "") {
    body.account_id = params.account_id;
  }
  return flowPost("/api/whatsapp/send/text", body);
}

/**
 * Resolve CRM contact then find-or-create conversation on flow.
 */
export async function serviceInitiateCoversation(params) {
  const contactId = params.contact_id;
  if (!contactId) {
    return { error: true, message: "contact_id is required", authorization: true, response_code: 0 };
  }
  const contactRes = await postRequest("contacts/detail", { id: contactId });
  if (contactRes?.error || !contactRes?.data?.details) {
    return contactRes?.error
      ? contactRes
      : { error: true, message: "Contact not found", authorization: true, response_code: 0 };
  }
  const c = contactRes.data.details;
  const cc = String(c.country_code || "").replace(/\D/g, "") || "91";
  const num = String(c.contact || "").replace(/\D/g, "");
  const merged = `${cc}${num}`;
  const convRes = await flowPost("/api/conversations/find-or-create", {
    contact: merged,
    country_code: cc,
    contact_id: String(c.id || c._id),
  });
  if (convRes?.error) return convRes;
  const mapped = mapFlowConversation(convRes.data, c);
  return { error: false, data: mapped, authorization: true, response_code: 1 };
}
